export const WORK_DIR_NAME = 'project';
export const WORK_DIR = `/home/${WORK_DIR_NAME}`;
export const MODIFICATIONS_TAG_NAME = 'dunea_file_modifications';
export const MODEL_REGEX = /^\[Model: (.*?)\]\n\n/;
export const PROVIDER_REGEX = /\[Provider: (.*?)\]\n\n/;
// Hidden marker prepended to a Continue/resume message. The full resume
// instructions travel in the message text (for the agent), but the chat UI
// detects this marker and renders a compact "Continue" chip instead of the
// bare text (see UserMessage). Stripped for display like the other markers.
export const RESUME_BUILD_MARKER = '[RESUME_BUILD]';
export const RESUME_BUILD_REGEX = /\[RESUME_BUILD\]\n\n/;
// Model is locked server-side; users never pick it. Kept only so legacy code
// paths have a value (the backend ignores any model the client sends).
export const DEFAULT_MODEL = 'z-ai/glm-5.2';
